import { useState } from 'react';
import Icon from '../../../components/AppIcon';

import { cn } from '../../../utils/cn';

const TagFilter = ({ selectedTags = [], onTagsChange, availableTags = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleTagToggle = (tag) => {
    const isSelected = selectedTags?.includes(tag);
    if (isSelected) {
      onTagsChange(selectedTags?.filter(t => t !== tag));
    } else {
      onTagsChange([...selectedTags, tag]);
    }
  };

  const handleClearAll = () => {
    onTagsChange([]);
  };

  const visibleTags = isExpanded ? availableTags : availableTags?.slice(0, 8);
  const hasMoreTags = availableTags?.length > 8;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-foreground flex items-center gap-2">
          <Icon name="Tags" size={16} color="var(--color-primary)" />
          Filter by Tags
        </label>
        {selectedTags?.length > 0 && (
          <button
            onClick={handleClearAll}
            className="text-xs text-primary hover:text-primary/80 transition-smooth"
          >
            Clear all
          </button>
        )}
      </div>

      {selectedTags?.length > 0 && (
        <div className="flex flex-wrap gap-2 p-3 bg-primary/5 border border-primary/10 rounded-md">
          <span className="text-xs text-muted-foreground">Active filters:</span>
          {selectedTags?.map((tag) => (
            <button
              key={tag}
              onClick={() => handleTagToggle(tag)}
              className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-md hover:bg-primary/90 transition-smooth"
            >
              {tag}
              <Icon name="X" size={12} />
            </button>
          ))}
        </div>
      )}

      <div className="flex flex-wrap gap-2">
        {visibleTags?.map((tag) => {
          const isSelected = selectedTags?.includes(tag);
          return (
            <button
              key={tag}
              onClick={() => handleTagToggle(tag)}
              className={cn(
                "px-3 py-1.5 text-sm font-medium rounded-md border transition-smooth",
                isSelected
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-background text-foreground border-border hover:border-primary hover:bg-primary/5"
              )}
            >
              {tag}
            </button>
          );
        })}
      </div>

      {hasMoreTags && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-sm text-primary hover:text-primary/80 transition-smooth flex items-center gap-1"
        >
          {isExpanded ? (
            <>
              <Icon name="ChevronUp" size={16} />
              Show less
            </>
          ) : (
            <>
              <Icon name="ChevronDown" size={16} />
              Show {availableTags?.length - 8} more tags
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default TagFilter;